import { Component, Input } from '@angular/core';
import { ReservaDTO } from 'src/app/core/types';

@Component({
  selector: 'reserva-info-view',
  templateUrl: './reserva-info-view.component.html',
  styleUrls: ['./reserva-info-view.component.scss'],
})
export class ReservaInfoViewComponent {
  @Input() reserva: ReservaDTO = {} as ReservaDTO;

  getCodigoReserva() {
    if (!this.reserva) {
      return '-';
    }

    return this.reserva?.codigo || '-';
  }

  getEmpreendimento() {
    if (!this.reserva) {
      return '-';
    }
    return this.reserva.unidade?.empreendimento?.nome || '-';
  }

  getUnidade() {
    if (!this.reserva) {
      return '-';
    }
    return this.reserva.unidade.numero || '-';
  }
}
